import * as React from "react";
import Container from "@mui/material/Container";
import MainContent from "./components/MainContent";
import WebsiteLayout from "../../layouts/website";

export default function Blog(props) {
  return (
    <React.Fragment>
      <WebsiteLayout>
        <Container
          maxWidth="lg"
          component="main"
          sx={{ display: "flex", flexDirection: "column", my: 16, gap: 4 }}
        >
          <MainContent />
        </Container>
      </WebsiteLayout>
    </React.Fragment>
  );
}


